import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/banner_30min.jpg'
import _imports_1 from '@/assets/banner_2hr_visit.jpg'
import _imports_2 from '@/assets/banner_nomination.jpg'
import _imports_3 from '@/assets/banner_2hr_nominate.jpeg'


const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "achieve-jupas-wrapper"
}
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "ion-text-center" }
const _hoisted_11 = { class: "ion-text-center" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "ion-text-center" }
const _hoisted_14 = { key: 5 }
const _hoisted_15 = { key: 0 }

import { ref, defineComponent, computed, watch, reactive, } from 'vue';

// icons
import { add, close, arrowBack, checkmarkCircle, alertCircle, ellipsisHorizontal, ellipsisVertical,
        pencil, qrCodeOutline, } from 'ionicons/icons';

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonFooter, IonRow, IonCol,
        IonItem, IonLabel, IonIcon, IonButtons, IonButton, IonSpinner, IonList,
        IonCard, IonCardHeader, IonCardSubtitle, IonCardContent, IonPopover, IonBadge,
        IonAccordion, IonAccordionGroup, IonText, IonChip, IonProgressBar, IonSegment, IonSegmentButton,
        loadingController, modalController, alertController, } from '@ionic/vue';
import SchoolTeacherModal from '@/components/teacher/SchoolTeacherModal.vue';
import StudentModal from '@/components/teacher/SchoolStudentModal.vue';
import ServiceModal from '@/components/modals/ServiceModal.vue';
import ABEventsModal from '@/components/secondary/events/ABEventsModal.vue';
import AB4CustomizeContentModal from '@/components/teacher/AB4CustomizeContentModal.vue';
import TeacherResponseQuestions from '@/components/teacher/TeacherResponseQuestions.vue';
import TeacherEventsModal from '@/components/teacher/TeacherEventsModal.vue';
import TeacherAchieveJUPASModal from '@/components/achievejupas/TeacherAchieveJUPASModal.vue';
import ServiceItem from '@/components/shared/ServiceItem.vue';
import ServiceAccordionGroup from '@/components/shared/ServiceAccordionGroup.vue';
import ActionAccordionGroup from '@/components/shared/ActionAccordionGroup.vue';
import TeacherItemQRCodeSharing from '@/components/teacher/TeacherItemQRCodeSharing.vue';
import TeacherItemSchoolReadiness from '@/components/teacher/TeacherItemSchoolReadiness.vue';
import FormQuestionModal from '@/components/modals/FormQuestionModal.vue';
import SLPModal from '@/components/secondary/ABSLPModal.vue';
import UserDetailsModal from '@/components/modals/UserDetailsModal.vue';

// composables
import { useI18n } from 'vue-i18n';
import { utils } from '@/composables/utils';
import { useStore } from '@/store';
import { AnchorEventTask, Service, Session, TeacherResponse, User } from '@/types';
import config from '@/config';


export default /*@__PURE__*/_defineComponent({
  __name: 'TeacherActionCardList',
  props: ['prefilledViewType'],
  setup(__props) {

// Vue reactivity
const props = __props;
// methods or filters
const store = useStore();
const { t } = useI18n();
const { openModal, closeModal, sleep, presentToast, presentPrompt, getQRCodeUrl, sendLinkToMyWhatsApp, formatDate,
        getIntakeYearOfDate, getCurrentIntakeYear, openImageModal, getProxyImgLink, copyText, dateDiffInDays, } = utils();

//const loadingData = computed(() => store.state.loadingUser || store.state.loadingData || store.state.loadingSchoolUserData);
const loadingData = computed(() => store.state.loadingUser || store.state.loadingData);
const user = computed(() => store.state.user);
const userRelatedSchool = computed(() => store.getters.userRelatedSchool);
const isAB4User = computed(() => store.getters.isAB4User);
const hasTeacherEvents = computed<Session[]>(() => store.getters.getSessionsByAnchorEventId('c0bcf00d0')).value.length > 0;

// TMP: for 14 Mar 2025 event
const anchorEventTasks = computed<AnchorEventTask[]>(() => store.state.anchorEventTasks);
const loadingUserFormResponses = computed(() => store.state.loadingUserFormResponses);
const userFormResponses = computed(() => store.state.userFormResponses);
const getFilteredFormQuestions = (task: AnchorEventTask) => (task.formQuestions.filter(q => (q.workServiceIds.length == 0 || q.workServiceIds.includes(props.ev.serviceId))));
const getTaskResponses = (tid: string) => (userFormResponses.value.filter(r => r.taskId == tid));
const isSubmittedTaskForm = (task: AnchorEventTask) => (getTaskResponses(task.id).length >= getFilteredFormQuestions(task).length);

// Work Services / Sessions
const workVisitEvents = computed<Session[]>(() => store.getters.getSessionsByAnchorEventId('work-campus-visit'));

// Toggle views
const targetForm = ref("F5-6");
const selectedViews = reactive({
  type: props.prefilledViewType || "AchieveJUPAS",
  subType: "resources",
}); // mainly for switching between AchieveJUPAS & Resources

// Filter service by school roles (or customized wordings)
const allSchoolRoles = computed(() => store.state.schoolRoles);
const userSchoolRoles = () => ((user.value.teacher?.schoolRoles || "").split(" , ").filter(r => r));
const selectedSchoolRole = ref(userSchoolRoles()[0] || ""); // XXX-related career prospect

// Services & actions
const services = computed<Service[]>(() => store.state.services);
const getFilteredServices = (targetPrincipalOnly = false, allowProposeDatesOnly: any = null) => {
  return services.value.filter(s => {
    if (s.type == "jobEX") return false;
    if (s.id == 'ucircle') return true; // special case: nominate students for UCircle
    if (allowProposeDatesOnly !== null && s.isAllowProposeDates != allowProposeDatesOnly) return false;
    if (s.isForPrincipalOnly != targetPrincipalOnly) return false;
    if (s.status == 'Inactive' || s.status == 'Removed') return false;
    return s.targetSchoolBands.length == 0 || userRelatedSchool.value?.id == 'beacon1' || s.targetSchoolBands.includes(userRelatedSchool.value?.band)
  });
}
const openUserDetails = async () => {
  const student = store.state.schoolStudents.find(s => s.phone == '52110402'); // TMP: CN for demo
  return await openModal(UserDetailsModal, { user: student, isStudentView: false, hideCommentSection: true, });
};

watch(targetForm, (curr) => {
  switch (curr) {
    case 'F4':
      selectedViews.type = 'AB4';
      break;
    default:
      selectedViews.type = 'AchieveJUPAS';
      break;
  }
})

const isPrincipal = computed(() => (user.value.teacher && userSchoolRoles().some(r => ["Principal", "Vice Principal"].includes(r))));
const filteredSchoolRoles = () => (config.formOptions.rolesInSchool.filter(r => !userSchoolRoles().includes(r)));
const getSchoolRoleAlias = (role: string) => (allSchoolRoles.value.find(r => r.title == role)?.alias || role);

// TMP: 14 Mar events
const openFormQuestionModal = async (task: AnchorEventTask) => {
  const { id: taskId, title, } = task;
  const formTitle = `${title}`; // modal title
  const oldResponses = getTaskResponses(taskId);
  const formQuestionIds = getFilteredFormQuestions(task).map(q => q.id);
  return await openModal(FormQuestionModal, { formTitle, formQuestionIds, taskId, oldResponses });
};
const achievejupasSurveyTask = computed(() => anchorEventTasks.value.find(t => t.id == 't7ef068da') as AnchorEventTask);
const achieveslpSurveyTask = computed(() => anchorEventTasks.value.find(t => t.id == 't47822ace') as AnchorEventTask);

const openStudentModal = async (initialSection = 2) => (await openModal(StudentModal, { schoolId: user.value.schoolId, initialSection }));

const openServiceModal = async (serviceId: any, event: any = null, props: any = {}) => {
  if (serviceId) {
    return await openModal(ServiceModal, { serviceId, event, ...props })
  }
};
const openABEventsModal = async (targetAnchorEvId) => (await openModal(ABEventsModal, { targetAnchorEvId }));
const openAB4CustomizeContentModal = async () => (await openModal(AB4CustomizeContentModal, { }));
const openTeacherEventsModal = async (anchorEvId) => (await openModal(TeacherEventsModal, { anchorEvId }));
const openSchoolTeacherModal = async () => (await openModal(SchoolTeacherModal, {}));
const openTeacherAchieveJUPASModal = async () => (await openModal(TeacherAchieveJUPASModal, {}));

// popover
const setPopoverOpen = (service: any, state: boolean, ev = null) => {
  service.popoverEvent = ev;
  service.isPopoverOpened = state;
}

// Filter service list based on teacher school banding
const groupedServices = (targetPrincipalOnly = false, allowProposeDatesOnly: any = null, targetForm: any = null, returnArr = false, scheduledServiceOnly = false) => {
  const obj = {}, filteredServices: any = [];
  const targetServices = getFilteredServices(targetPrincipalOnly, allowProposeDatesOnly);
  for (const service of targetServices) {
    if (targetForm && service.targetForms && service.targetForms.length > 0 && !service.targetForms.includes(targetForm)) {
      continue; // only include services related to the form
    }
    let group = service.nature || 'Others';
    //if (service.id == 'mock-jupas') group = "FDMT unique";
    if (service.id == 'mock-jupas') group = "2. AchieveJUPAS";
    else if (group == 'Talk at your school') group = "3. University lecture at your school";
    //else if (group == 'Talk at your school') group = "[Subject enrichment] 30-min University lecture at your school";
    else if (group == "Workshop") group = "[Post-exam period] 4-hr university workshop";
    //else if (group == "Visit") group = "[Annual outing] 2-hr university visit";
    else if (group == "Visit") group = "1. Work visits";
    else if (group == "20-min Online Briefing") group = "[Class teacher session] 15-min Zoom reminders";
    //if (group == "Workshop") group = "Nominate students to Workshops on university campus";
    //else if (group == "Visit") group = "Lead students to University visits at schools’ preferred time";
    obj[group] = obj[group] || [];
    obj[group].push(service);
    filteredServices.push(service);
  }
  return returnArr ? filteredServices : obj;
}

// For view switching between forms & type
const getServicesByNature = (nature) => {
  const filteredServices = getFilteredServices();
  if (nature == 'Video') return filteredServices.filter(s => s.name.toLowerCase().includes(" preview"));
  return filteredServices.filter(s => s.nature === nature && !s.name.toLowerCase().includes(" preview"));
}

// AchieveSLP
const openSLPModal = async (isPreview = false) => {
  const ev = store.getters.getLastAttendedSession;
  return await openModal(SLPModal, { isPreview, ev, serviceId: ev?.serviceId, relatedProgramId: ev?.relatedProgramId, relatedClientId: user.value.clientId }, "", false)
}

return (_ctx: any,_cache: any) => {
  const _component_home_action_item = _resolveComponent("home-action-item")!

  return (loadingData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonSpinner))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_unref(IonToolbar), { class: "sticky-toolbar" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSegment), {
              class: "view-type-segment",
              mode: "ios",
              modelValue: selectedViews.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedViews.type) = $event)),
              scrollable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonSegmentButton), {
                  value: "Sharing",
                  class: "short-segment-btn ion-text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      size: "small",
                      icon: _unref(qrCodeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "Checklist" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createElementVNode("b", null, "Checklist", -1)
                      ])),
                      _: 1,
                      __: [9]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "AchieveJUPAS" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), {
                      style: {"line-height":"1.5"},
                      class: "no-text-transform"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createElementVNode("b", null, "AchieveJUPAS", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("2.0")
                      ])),
                      _: 1,
                      __: [10]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "AchieveSNDAS" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), {
                      style: {"line-height":"1.5"},
                      class: "no-text-transform"
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createElementVNode("b", null, "AchieveSNDAS", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("(beta)")
                      ])),
                      _: 1,
                      __: [11]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "AchieveSLP" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), {
                      style: {"line-height":"1.5"},
                      class: "no-text-transform"
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createElementVNode("b", null, "AchieveSLP", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("events")
                      ])),
                      _: 1,
                      __: [12]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonSegmentButton), { value: "school-funded" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), {
                      style: {"line-height":"1.5"},
                      class: "no-text-transform"
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("School-funded")
                      ])),
                      _: 1,
                      __: [13]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (selectedViews.type == 'AchieveSLP')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_unref(IonSegment), {
                    mode: "ios",
                    modelValue: selectedViews.subType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedViews.subType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonSegmentButton), { value: "resources" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode("School-based")
                            ])),
                            _: 1,
                            __: [14]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonSegmentButton), { value: "nomination" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode("Joint-school")
                            ])),
                            _: 1,
                            __: [15]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_unref(IonToolbar), { style: {"--min-height":"27px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), {
                        lines: "full",
                        button: "",
                        detail: "",
                        color: "fdmtred",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (openSLPModal(true)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { class: "ion-text-wrap ion-text-center" }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createElementVNode("p", { style: {"margin":"0","color":"#fff"} }, "AchieveSLP preview", -1)
                            ])),
                            _: 1,
                            __: [16]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (selectedViews.type == 'Sharing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(TeacherItemQRCodeSharing)
            ]))
          : _createCommentVNode("", true),
        (selectedViews.type == 'Checklist')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(TeacherItemSchoolReadiness)
            ]))
          : _createCommentVNode("", true),
        (selectedViews.type == 'AchieveSNDAS')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
          : _createCommentVNode("", true),
        (selectedViews.type == 'AchieveJUPAS')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(TeacherAchieveJUPASModal, { isDemo: true })
            ]))
          : _createCommentVNode("", true),
        (selectedViews.type === 'AchieveSLP')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (selectedViews.subType === 'resources')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[17] || (_cache[17] = _createElementVNode("img", {
                      src: _imports_0,
                      style: {"width":"100%","margin-bottom":"-3px"}
                    }, null, -1)),
                    _createVNode(ActionAccordionGroup, {
                      expandAll: true,
                      "no-header": true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesByNature('Talk at your school'), (service) => {
                            return (_openBlock(), _createBlock(ServiceItem, {
                              key: service.id,
                              service: service
                            }, null, 8, ["service"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }),
                    _cache[18] || (_cache[18] = _createElementVNode("img", {
                      src: _imports_1,
                      style: {"width":"100%","margin-bottom":"-3px"}
                    }, null, -1)),
                    _createVNode(ActionAccordionGroup, {
                      expandAll: true,
                      "no-header": true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesByNature('Visit'), (service) => {
                            return (_openBlock(), _createBlock(ServiceItem, {
                              key: service.id,
                              service: service
                            }, null, 8, ["service"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : (selectedViews.subType === 'nomination')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _cache[19] || (_cache[19] = _createElementVNode("img", {
                        src: _imports_2,
                        style: {"width":"100%","margin-bottom":"-3px"}
                      }, null, -1)),
                      _createVNode(ActionAccordionGroup, {
                        expandAll: true,
                        "no-header": true
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesByNature('Workshop'), (service) => {
                              return (_openBlock(), _createBlock(ServiceItem, {
                                key: service.id,
                                service: service
                              }, null, 8, ["service"]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _cache[20] || (_cache[20] = _createElementVNode("img", {
                        src: _imports_3,
                        style: {"width":"100%","margin-bottom":"-3px"}
                      }, null, -1)),
                      _createVNode(ActionAccordionGroup, {
                        expandAll: true,
                        "no-header": true
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workVisitEvents.value.filter(ev => !ev.clientSchoolId && _unref(dateDiffInDays)(ev.date, new Date()) < 120), (ev) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_home_action_item, {
                              key: ev.id,
                              onClick: ($event: any) => (openServiceModal(ev.serviceId, ev, true)),
                              isLesson: true,
                              title: `${ev.name} (${ev.date} ${ev.startTime})`
                            }, null, 8, ["onClick", "title"])), [
                              [_vShow, user.value.isAdmin || (!ev.clientSchoolId || ev.clientSchoolId == user.value.schoolId)]
                            ])
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (selectedViews.type == 'school-funded')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (!isAB4User.value)
                ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), {
                        class: "ion-text-wrap",
                        style: {"line-height":"1"}
                      }, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createElementVNode("i", null, "School-funded services for F4 & F3 only available upon school request after 3+ years of university-funded service", -1)
                        ])),
                        _: 1,
                        __: [21]
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(ActionAccordionGroup, { expandAll: true }, {
                header: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, "Bluebird Seed")
                  ], -1)
                ])),
                default: _withCtx(() => [
                  (user.value.schoolId == 'htc')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_home_action_item, {
                          isLesson: true,
                          title: "Videos and regulations",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (openServiceModal('bluebird-seed', null, { hideApplyBtn: true })))
                        }),
                        _createVNode(ActionAccordionGroup, {
                          expandAll: false,
                          "header-color": 'none',
                          "no-padding": true
                        }, {
                          header: _withCtx(() => [
                            _createVNode(_unref(IonItem), { lines: "full" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createElementVNode("b", null, "5D22 Ng Wing Sum Chloe", -1)
                                  ])),
                                  _: 1,
                                  __: [23]
                                }),
                                _createVNode(_unref(IonButtons), { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonButton), {
                                      class: "no-text-transform",
                                      size: "small",
                                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (openUserDetails()), ["stop"]))
                                    }, {
                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createTextVNode("Profile")
                                      ])),
                                      _: 1,
                                      __: [24]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), {
                              lines: "full",
                              style: {"padding-left":"32px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  icon: _unref(checkmarkCircle),
                                  color: "success"
                                }, null, 8, ["icon"]),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createElementVNode("b", null, "Nominator: Ms. Lillian Ho", -1)
                                  ])),
                                  _: 1,
                                  __: [25]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonItem), {
                              lines: "full",
                              style: {"padding-left":"32px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                                    _createElementVNode("b", null, "Co-supervisors: Ms. Lilian Ho (HTC), Brandon Chan (FDMT)", -1)
                                  ])),
                                  _: 1,
                                  __: [26]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(ActionAccordionGroup, {
                              style: {"padding-left":"20px"},
                              expandAll: false,
                              "header-color": 'none',
                              "no-padding": true
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), { lines: "full" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                                        _createElementVNode("b", null, "Project logs", -1)
                                      ])),
                                      _: 1,
                                      __: [27]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  button: "",
                                  lines: "full",
                                  style: {"padding-left":"32px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                                        _createElementVNode("b", null, "AchieveJUPAS UI Updates", -1),
                                        _createElementVNode("p", null, "Show version history of program choices", -1),
                                        _createElementVNode("p", null, "Expected completion: 2025-04-30", -1)
                                      ])),
                                      _: 1,
                                      __: [28]
                                    }),
                                    _createVNode(_unref(IonBadge), {
                                      color: "medium",
                                      slot: "end"
                                    }, {
                                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                                        _createTextVNode("Planned")
                                      ])),
                                      _: 1,
                                      __: [29]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(ActionAccordionGroup, { expandAll: true }, {
                header: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, "Form 4")
                  ], -1)
                ])),
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    lines: "full",
                    button: "",
                    detail: "",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (openAB4CustomizeContentModal())),
                    disabled: !user.value.isAdmin && !isAB4User.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                          _createElementVNode("p", null, "Pre-session customization for your school", -1)
                        ])),
                        _: 1,
                        __: [31]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_unref(IonItem), {
                    lines: "full",
                    button: "",
                    detail: "",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (openABEventsModal('abs-session1'))),
                    disabled: !isAB4User.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createElementVNode("p", null, "[80+ min] Lesson 1", -1)
                        ])),
                        _: 1,
                        __: [32]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_unref(IonItem), {
                    lines: "full",
                    button: "",
                    detail: "",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (openABEventsModal('abs-session2'))),
                    disabled: !isAB4User.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createElementVNode("p", null, "[40+ min] Lesson 2", -1)
                        ])),
                        _: 1,
                        __: [33]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_unref(IonItem), {
                    lines: "full",
                    button: "",
                    detail: "",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        size: "small",
                        color: "danger",
                        icon: _unref(alertCircle)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createTextVNode("Manage student worries")
                        ])),
                        _: 1,
                        __: [34]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(ActionAccordionGroup, { expandAll: true }, {
                header: _withCtx(() => _cache[35] || (_cache[35] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, "AchieveElective")
                  ], -1)
                ])),
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    lines: "full",
                    button: "",
                    detail: "",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (openABEventsModal('ab3-session1'))),
                    disabled: !isAB4User.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[36] || (_cache[36] = [
                          _createElementVNode("p", null, "[45+ min] Lesson 1", -1)
                        ])),
                        _: 1,
                        __: [36]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})